export const SHOW_RADIAL_BLUR = true;
export const SHOW_THUMBNAIL_BLUR = true;
